import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.loading.season');
import { OnInit, Input } from '@angular/core';

@Component({
    standalone: false,
    selector: 'wiz-portal-season-loading-season',
    templateUrl: './view.html',
    styleUrls: []
})
export class PortalSeasonLoadingSeasonComponent implements OnInit {
    @Input() className: any = "w-5 h-5 text-orange";

    public async ngOnInit() {
    }
}

export default PortalSeasonLoadingSeasonComponent;